import React, { useState, useEffect, useCallback, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom"; // Detect URL changes
import { Helmet } from "react-helmet";
import Breadcrumb from "../components/Breadcrumb";
import BlogBigCard from "../components/BlogBigCard";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";

import SearchWidget2 from "../components/SearchWidget2";

const BlogsFilterSearch = lazy(() => import("../components/BlogsFilterSearch"));

const API_HOST = process.env.REACT_APP_API_URL;

const Blogs = () => {
  const location = useLocation(); // Detects changes in URL
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  // Extract filters from URL
  const getFiltersFromURL = () => {
    const urlParams = new URLSearchParams(location.search);
    return {
      tag: urlParams.get("tag") || "",
      category: urlParams.get("category") || "",
      query: urlParams.get("query") || "",
    };
  };

  // Function to fetch blogs (resets if new query)
  const fetchBlogs = useCallback(
    async (newPage = 1, reset = false) => {
      try {
        const { tag, category, query } = getFiltersFromURL();
        const encodedTag = encodeURIComponent(tag);
        const encodedCategory = encodeURIComponent(category);
        const encodedQuery = encodeURIComponent(query);

        const response = await axios.get(
          `${API_HOST}blogs/showBlogs?page=${newPage}&limit=25${
            tag ? `&tag=${encodedTag}` : ""
          }${category ? `&category=${encodedCategory}` : ""}${
            query ? `&query=${encodedQuery}` : ""
          }`
        );

        setBlogs((prev) => (reset ? response.data.blogs : [...prev, ...response.data.blogs]));
        setHasMore(response.data.hasMore);
        setPage(newPage + 1);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    },
    [location.search] // Depend on URL changes
  );

  // Re-fetch blogs when URL params change
  useEffect(() => {
    setPage(1);
    setBlogs([]); // Clear old blogs
    fetchBlogs(1, true); // Fetch fresh data
  }, [location.search]); // Ensure it listens to URL changes

  return (
    <>
      <Helmet>
        <title>Blogs - Om Softwares | Digital Marketing & Web Development Insights</title>
        <meta name="description" content="Read the latest blogs from Om Softwares on digital marketing, web development, SEO tips, social media strategies, and visual branding insights." />
        <meta property="og:title" content="Blogs - Om Softwares" />
        <meta property="og:description" content="Read the latest blogs on digital marketing, web development, SEO, and social media strategies." />
        <meta property="og:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
        <meta property="og:url" content="https://omsoftwares.in/blogs" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Blogs - Om Softwares" />
        <meta name="twitter:description" content="Read the latest blogs on digital marketing, web development, SEO, and social media strategies." />
        <meta name="twitter:image" content="https://omsoftwares.in/assets/img/seo/ogImage.png" />
      </Helmet>
      <Breadcrumb name="Blogs" />
      <SearchWidget2/>
      <section className="blog pt-110 pb-130">
        <div className="container">
          <div className="row mt-none-30">
            <div className="col-lg-8 mt-30">
              <div className="blog-post-wrapper">
                <InfiniteScroll
                  dataLength={blogs.length}
                  next={() => fetchBlogs(page)}
                  hasMore={hasMore}
                  loader={<p className="text-center text-gray-500 mt-4">Loading more...</p>}
                  endMessage={<p className="text-center text-gray-500 mt-4">No more blogs available.</p>}
                >
                  {blogs.map((blog, index) => (
                    <BlogBigCard
                      key={index}
                      blog={blog}
                      comment={blog.commentCount || 0}
                    />
                  ))}
                </InfiniteScroll>
              </div>
            </div>

              <Suspense fallback={<div>Loading filters...</div>}>
                <BlogsFilterSearch />
              </Suspense>
            
          </div>
        </div>
      </section>
    </>
  );
};

export default Blogs;
